<template>
    <body>
    <div id="fix_header">
        <h2><span style="font-size: 15px">{{this.offices_counter}}</span> Offices
            <button class="button_add" @click.prevent="createNewOffice"> <i class="fa fa-plus" aria-hidden="true"></i>
                New
            </button>
            <button class="button_back" @click="cancel_goback">&#11013;</button>
        </h2>
        <input v-if="offices_counter > 0" type="text" id="searchInput" @keyup="searchOffice()" placeholder="Search for Office" title="Type name...">
    </div>
    <div v-if="offices_counter == 0">
        {{this.error_message}}
    </div>
    <div v-else style="overflow-x: auto">
        <br>
        <table id="bmTable">
          <tbody>
          <tr class="header">
            <th width="20%">Office Name</th>
            <th width="20%"><i class="fa fa-map-marker" aria-hidden="true"> Location</i></th>
            <th width="20%"><i class="fa fa-building-o" aria-hidden="true"> Type</i></th>
            <th width="15%">Schedule</th>
            <th width="15%">Edit</th>
            <th width="10%">Delete</th>
          </tr>
          <tr v-for="(office,index) in this.offices " :key="office.index">
            <td>{{office.name}}</td>
            <td>{{office.location}}</td>
            <td>{{office.type}}</td>
            <td>
              <button  class="text_btn request" @click="viewOffice(office)">
                <i class="fa fa-hourglass-half" aria-hidden="true"></i>
              </button>
            </td>
            <td>
              <button class="text_btn confirm" @click="editOffice(office)">
                <i class="fa fa-pencil" aria-hidden="true"></i>
              </button>
            </td>
            <td>
              <button class="text_btn danger" @click="deleteOffice(office,index)">
                <i class="fa fa-trash-o" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        <!-- MOBILE TABLE -->
        <div id="mobileTable" v-for="(office,index) in this.offices " :key="office.index">
            <div class="client_card" >
                <div class="client_card_container" >
                    <span class="idvalue">#{{index+1}}</span>
                    <span class="oname">{{office.name}}</span>
                    <hr>
                    <span>
                        <button class="text_btn " @click="showOfficeInfo(office.type)">
                            <i class="fa fa-building" aria-hidden="true"></i>
                        </button>
                    </span>
                    <span v-if="office.type === 'pet sitter'">
                        <button class="text_btn ">
                            &#128054;
                        </button>
                    </span>
                    <span>
                        <button class="text_btn expired" @click="showOfficeInfo(office.location)">
                            <i class="fa fa-map-marker" aria-hidden="true" ></i>
                        </button>
                    </span>
                    <span>
                        <button  class="text_btn request" @click="viewOffice(office)">
                            <i class="fa fa-hourglass-half" aria-hidden="true"></i>
                        </button>
                    </span>
                    <span>
                        <button class="text_btn confirm" @click="editOffice(office)">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                        </button>
                    </span>
                    <span>
                        <button class="text_btn cancel" @click="deleteOffice(office,index)">
                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                        </button>
                    </span>
                </div>
            </div>
            <br>
        </div>
    </div>
    <!-- status history -->
    <br>
    <div>
        <span class="text_btn expired">
            <i class="fa fa-map-marker" aria-hidden="true" ></i><span style="font-size: 7px"> Location</span>
        </span>
        <span class="text_btn otype">
             <i class="fa fa-building" aria-hidden="true"></i><span style="font-size: 7px"> Type</span>
        </span>
        <span class="text_btn confirm">
            <i class="fa fa-pencil" aria-hidden="true"></i><span style="font-size: 7px"> Edit</span>
        </span>
        <span  class="text_btn request">
            <i class="fa fa-hourglass-half" aria-hidden="true"></i><span style="font-size: 7px"> Schedule</span>
        </span>
        <span class="text_btn cancel">
            <i class="fa fa-trash-o" aria-hidden="true"></i><span style="font-size: 7px"> Delete</span>
        </span>
    </div>
    </body>
</template>
<script>
    import {getBaseURL} from '../url_endpoints.js'
    export default {
        name: 'Offices',
        data() {
            return {
                offices:[],
                fix_header:null,
                sticky_zone:null,
                baseURL: null,
                error_message:'No offices found!',
            }
        },
        computed: {
            offices_counter() {
                return this.offices.length
            }
        },
        mounted() {
            this.fix_header = document.getElementById('fix_header')
            this.sticky_zone = this.fix_header.offsetTop
            window.onscroll = () => this.setStickyHeader()
            // set back-end endpoints
            this.baseURL = getBaseURL()
            this.getOffices()
        },
        methods: {
            showOfficeInfo(info){
               alert(info)
            },
            setStickyHeader() {
                if(window.pageYOffset > this.sticky_zone){
                    this.fix_header.classList.add('sticky_header')
                } else {
                    this.fix_header.classList.remove('sticky_header')
                }
            },
            cancel_goback() {
               this.$router.push('/features')
                window.scrollTo(0,0)
            },
            createNewOffice(){
                this.$store.commit('setSelectedOffice',null)
                this.$router.push('/new_office')
            },
            searchOffice() {
                let input, filter, table, tr, td, txtValue
                input = document.getElementById("searchInput")
                filter = input.value.toUpperCase()
                table = document.getElementById("bmTable")
                tr = table.getElementsByTagName("tr")
                for(let i = 0; i < tr.length; i++) {
                    td = tr[i].getElementsByTagName("td")[0] // get Office name
                    if (td) {
                        txtValue = td.textContent || td.innerText
                        if (txtValue.toUpperCase().indexOf(filter) > -1) {
                            tr[i].style.display = ""
                        } else {
                            tr[i].style.display = "none"
                        }
                    }
                }
            },
            viewOffice(office) {
                alert('Office open hours: ' + office.open +'\nOffice close hours: '+office.close +
                    '\nAppointment slot time: '+office.slot + ' minutes')
            },
            editOffice(office){
                this.$store.commit('setSelectedOffice',office)
                this.$router.push('/new_office')
            },
            getOffices() {
                const business = this.$store.getters.getCurrentBusiness
                fetch(this.baseURL + '/offices?bid='+business.id).then(rsp => {
                    return rsp.json()
                }).then( response => {
                    //console.log(response)
                    for(let office of response) {
                        this.offices.push(office)
                    }
                    // store number of offices for current business
                    this.$store.commit('setNumberOffices',this.offices.length)
                }).catch(err => {
                    alert(err.message+'\nBackend Server could be down!\nPlease try again later....')
                    //console.log('Error when get offices', err.message)
                })
            },
            deleteOffice(office,index){
                let y = confirm(`This action will delete the next office: ${office.name} \n Are You sure ?`)
                if(y) {
                    fetch(this.baseURL + '/offices/' + office.id, {
                        method: 'DELETE'
                    }).then( rsp =>{
                        return rsp.json()
                    }).then( () => {
                        //console.log('Delete office proceeded...')
                        // update frontend sites data
                        this.offices.splice(index,1)
                    }).catch(err => {
                        //console.log('Error when delete office ...'+err.message)
                        this.error_message = err.message
                    })
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    body {
        height:100vh;
    }
    * {
        box-sizing: border-box;
    }
    #searchInput {
        background-image: url('../assets/search_icon_25.png');
        background-position: 5px 5px;
        background-repeat: no-repeat;
        width: 30%;
        font-size: 12px;
        padding: 10px 20px 10px 40px;
        border: 1px solid #ddd;
        margin-bottom: 12px;
    }

    #bmTable {
        border-collapse: collapse;
        width: 100%;
        border: 1px solid #ddd;
        font-size: 15px;
    }

    #bmTable th, #bmTable td {
        text-align: left;
        padding: 12px;
        color: white;
    }

    #bmTable tr {
        border-bottom: 1px solid #ddd;
    }

    #bmTable tr.header {
        background-color: dodgerblue;
    }
    #bmTable tr:hover {
        background-color: darkslategrey;
    }
    // ******************** round button
    .button_add {
        background-color: lightcyan;
        color: black;
        border: none;
        padding: 5px 5px;
        font-size: 14px;
        font-family: Raleway;
        cursor: pointer;
        border-radius: 10px;
        opacity: 0.7;
    }
    .button_add:hover {
        opacity: 1.0;
    }
    .button_back {
        @extend .button_add;
        background-color: white;
        font-size: 15px;
        margin-left: 5px;
        float: left;
    }
    .button_filter {
        @extend .button_add;
        background-color: #1e90ff;
    }
    .button_check {
        @extend  .button_add;
        font-size: 20px;
        background-color: #4caf50;
    }
    .button_check[disabled] {
        background-color: #aaaaaa;
    }
    // add sticky header of this wiew
    .sticky_header {
        position: fixed;
        top:0;
        left:0;
        width: 100%;
        background-color: #2c3e50;
        z-index: 1;
    }

    // add few text buttons styles
    @import "../assets/css/text_buttons";
    /********************* MAKE RESPONSIVE **********************/
    @import "../assets/css/offices_mobile";

    .otype {
        color: yellow;
    }
    .otype:hover{
        color: white;
    }
</style>